/** Environment type badge with brand-aligned colors.
 *
 * Types: development | qa | uat | staging | production | custom
 */
const COLORS = {
  development: { bg: "rgba(59,130,246,0.12)", text: "#3B82F6", border: "rgba(59,130,246,0.25)" },
  qa: { bg: "rgba(168,85,247,0.12)", text: "#A855F7", border: "rgba(168,85,247,0.25)" },
  uat: { bg: "rgba(245,158,11,0.14)", text: "#D97706", border: "rgba(245,158,11,0.30)" },
  staging: { bg: "rgba(6,182,212,0.12)", text: "#0891B2", border: "rgba(6,182,212,0.25)" },
  production: { bg: "rgba(239,68,68,0.12)", text: "#DC2626", border: "rgba(239,68,68,0.30)" },
  custom: { bg: "rgba(100,116,139,0.12)", text: "#64748B", border: "rgba(100,116,139,0.25)" },
};

const LABELS = {
  development: "Dev",
  qa: "QA",
  uat: "UAT",
  staging: "Staging",
  production: "Production",
  custom: "Custom",
};

export function EnvironmentBadge({ type = "custom", name, testId, size = "sm" }) {
  const c = COLORS[type] || COLORS.custom;
  const px = size === "lg" ? "px-2.5 py-0.5 text-xs" : "px-1.5 py-0.5 text-[10px]";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 ${px} rounded font-mono font-medium tracking-wide whitespace-nowrap border`}
      style={{ backgroundColor: c.bg, color: c.text, borderColor: c.border }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: c.text }} />
      {name || LABELS[type]}
    </span>
  );
}

export function ProductionWarningBanner({ message = "Running against Production — destructive tests are blocked.", testId = "prod-warning-banner" }) {
  return (
    <div
      data-testid={testId}
      className="mb-4 flex items-center gap-3 px-4 py-3 rounded-md border border-[#FECACA] bg-[#FEF2F2] text-[#991B1B] dark:bg-[#450A0A]/60 dark:border-[#7F1D1D] dark:text-[#FCA5A5]"
    >
      <span className="w-2 h-2 rounded-full bg-[#EF4444] animate-pulse" />
      <span className="text-sm font-medium">{message}</span>
    </div>
  );
}
